import { NgClass } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from "@angular/core";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { BlockComponent } from "../../container-block/block.component";
import { HeaderComponent } from "../../header/header.component";
import { IconComponent } from "../../icon/icon.component";

export type CardIntentType = "save" | "delete" | "edit";

export type CardIntentSize = 2 | 3 | 4;

@Component({
    selector: "rask-card",
    templateUrl: "./card.component.html",
    styleUrls: ["./card.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        HeaderComponent,
        IconComponent,
        NgClass
    ]
})
export class CardComponent {
    @Input() label: string;

    @Input() href: string;

    @Input() size: CardIntentSize = 4;

    @Input() renderRaskheader = true;

    @Input() intent: CardIntentType;

    @Output() iconClick = new EventEmitter();

    @Input() headerIcon: string;

    @Input() headerIconDisabled = false;

    get showHeader(): boolean {
        return !ObjectUtils.isNullOrUndefined(this.intent);
    }

    get showHeaderIcon(): boolean {
        return !ObjectUtils.isNullOrUndefined(this.headerIcon);
    }

    get isLink(): boolean {
        return ObjectUtils.stringHasValue(this.href);
    }

    get iconClass(): string {
        switch (this.intent) {
            case "save":
                return "far fa-save warning-orange";
            case "delete":
                return "far fa-trash-alt warning-red";
            case "edit":
                return "far fa-pencil warning-orange";
            default:
                return "";
        }
    }

    clicked() {
        if (!this.headerIconDisabled) {
            this.iconClick.emit();
        }

    }
}
